import React from 'react';
import { Link } from 'react-router-dom';
import { HeroStage } from '../components/HeroStage';
import { Reveal } from '../components/Reveal';
import { Disclosure } from '../components/Disclosure';
import { SeoHead } from '../components/SeoHead';
import { positioning, capabilitySummary, markets, clients, faqs } from '../data/seo';
const title = 'Breezy Experiential — Experiential Marketing & Mobile Pop-Up Production Studio';
const description = 'Breezy Experiential is a creative experiential production studio based in Los Angeles, with hubs in Dallas and New York, producing mobile retail pop-ups, national sampling tours, influencer events, brand activations and tradeshow booths nationwide.';
const structuredData = [{
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Breezy Experiential',
  description: positioning,
  email: 'info@heybreezy.co',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Los Angeles',
    addressRegion: 'CA',
    addressCountry: 'US'
  },
  areaServed: 'United States',
  location: [{
    '@type': 'Place',
    name: 'Los Angeles, CA'
  }, {
    '@type': 'Place',
    name: 'Dallas, TX'
  }, {
    '@type': 'Place',
    name: 'New York, NY'
  }],
  knowsAbout: capabilitySummary.map(item => item.title)
}, {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(faq => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer
    }
  }))
}];
export function Home() {
  return <div data-id="element-257" data-mp="287kpfe51f1sp">
      <SeoHead title={title} description={description} structuredData={structuredData} data-id="element-258" data-mp="2895nhdqk92vb" />

      <div className="sticky top-[4.5rem] -z-0" data-id="element-259" data-mp="23am0da08dl1d">
        <HeroStage data-id="element-260" data-mp="1z7662kbmvwru" />
      </div>

      <section className="relative z-10 bg-ink" data-id="element-261" data-mp="1z6e9b66avszz">
        <div className="mx-auto max-w-page px-6 py-14 md:px-10 md:py-20" data-id="element-262" data-mp="1z98skudkv7rt">
          <Reveal data-id="element-263" data-mp="1u94ltw2h1res">
            <p className="max-w-xl text-sm leading-relaxed text-muted md:text-base" data-id="element-264" data-mp="1uap70v2wbxzz">
              A creative experiential production studio — mobile pop-ups,
              national tours, activations, tradeshows and conferences, built and
              run end to end.
            </p>
          </Reveal>
        </div>

        <div className="mx-auto max-w-page px-6 pb-16 md:px-10 md:pb-24" data-id="element-265" data-mp="1fle0qvtkv9cf">
          <h2 className="border-b border-line pb-4 text-[0.65rem] uppercase tracking-micro text-lilac" data-id="element-266" data-mp="1fnqj3a38zlq0">
            More on the studio
          </h2>

          <Disclosure eyebrow="01" label="What we do" data-id="element-267" data-mp="2899upsrrin5i">
            <dl className="grid max-w-3xl gap-x-10 gap-y-6 sm:grid-cols-2" data-id="element-268" data-mp="28c4inu9ziq3o">
              {capabilitySummary.map(item => <div key={item.title} data-id="element-269" data-mp="1yjyme8cp9mio">
                  <dt className="font-display text-sm uppercase leading-none text-cream" data-id="element-270" data-mp="1yixa60jy6tzd">
                    {item.title}
                  </dt>
                  <dd className="mt-2 text-sm leading-relaxed text-muted" data-id="element-271" data-mp="2r0j7cawtxs1b">
                    {item.text}
                  </dd>
                </div>)}
            </dl>
            <Link to="/about" className="mt-7 inline-block text-[0.65rem] uppercase tracking-micro text-muted transition-colors hover:text-lilac" data-id="element-272" data-mp="fjhegag8b1xd">
              Full capabilities
            </Link>
          </Disclosure>

          <Disclosure eyebrow="02" label="Who we are" data-id="element-273" data-mp="kd2d84pnbzxm">
            <p className="max-w-2xl text-sm leading-relaxed text-muted" data-id="element-274" data-mp="3ss2m7gd72hvh">
              {positioning}
            </p>
          </Disclosure>

          <Disclosure eyebrow="03" label="Where we work" data-id="element-275" data-mp="3nutyl09a1lmu">
            <p className="max-w-2xl text-sm leading-relaxed text-muted" data-id="element-276" data-mp="5o5undpyr4ir">
              Based in Los Angeles, California, with main hubs in Dallas and New
              York, producing nationally — {markets.join(', ')}.
            </p>
          </Disclosure>

          <Disclosure eyebrow="04" label="Selected clients" data-id="element-277" data-mp="1h0yn6qqkvwzv">
            <p className="max-w-2xl text-sm leading-relaxed text-muted" data-id="element-278" data-mp="1c2ooi65nae9i">
              {clients.join(' · ')}
            </p>
            <Link to="/work" className="mt-6 inline-block text-[0.65rem] uppercase tracking-micro text-muted transition-colors hover:text-lilac" data-id="element-279" data-mp="27fg4kp4jk64e">
              See the work
            </Link>
          </Disclosure>

          <Disclosure eyebrow="05" label="Our fleet" data-id="element-280" data-mp="2mbozjehefxb0">
            <p className="max-w-2xl text-sm leading-relaxed text-muted" data-id="element-281" data-mp="2m92r7cmopdrq">
              We own and operate four mobile vehicles — Lil’ Breezy (12′, merch
              and sampling), Ezzy (15′, versatile retail), Big Breezy (18′, food
              truck) and Breezy Mambo (22′, full-service culinary and beverage)
              — and can source or fabricate custom carts, trailers and
              containers for anything else a program needs.
            </p>
            <Link to="/fleet" className="mt-6 inline-block text-[0.65rem] uppercase tracking-micro text-muted transition-colors hover:text-lilac" data-id="element-282" data-mp="3a1rovmtxip5x">
              Meet the fleet
            </Link>
          </Disclosure>

          {faqs.map((faq, index) => <Disclosure key={faq.question} eyebrow={String(index + 6).padStart(2, '0')} label={faq.question} data-id="element-283" data-mp="ycbpg17g3q2n" data-mpi={index}>
              <p className="max-w-2xl text-sm leading-relaxed text-muted" data-id="element-284" data-mp="ofgshmqtlxqh">
                {faq.answer}
              </p>
            </Disclosure>)}
        </div>

        <div className="mx-auto flex max-w-page flex-wrap items-center justify-between gap-4 border-t border-line px-6 py-10 text-[0.65rem] uppercase tracking-micro text-muted md:px-10" data-id="element-285" data-mp="1m51yo2nyrv98">
          <Link to="/contact" className="transition-colors hover:text-lilac" data-id="element-286" data-mp="1cbbf9c6p2b0e">
            Start a project
          </Link>
          <a href="mailto:info@heybreezy.co" className="transition-colors hover:text-lilac" data-id="element-287" data-mp="17c8i0dwyh92z">
            info@heybreezy.co
          </a>
          <span data-id="element-288" data-mp="2015nfgg2jbeb">© {new Date().getFullYear()} Breezy Experiential</span>
        </div>
      </section>
    </div>;
}